// Core
import React, { useState } from 'react';
import { useQuery } from 'react-query';
import { 
  Box, 
  Button, 
  Flex, 
  Text, 
  Grid, 
  Divider, 
  Image,
  FormControl,
  FormLabel,
  FormHelperText,
  Input,
  Textarea
} from '@chakra-ui/react';
import { useHistory } from 'react-router-dom';

// Assets
import glow from 'assets/img/glow-9.png';
import { apiService } from 'services/ApiService';

// Components
import { StarsIcon } from 'components/Icons/Icons';
import Breadcrumbs from 'components/Breadcrumbs/Breadcrumbs';
import ErrorCard from 'components/Form/Errors';

const TicketCreate = () => {
  const [title, setTitle] = useState('');
  const [message, setMessage] = useState('');

  const [errorCard, setErrorCard] = useState();

  const [isValidInputTitle, setIsValidInputTitle] = useState(true);   
  const [isValidInputMessage, setIsValidInputMessage] = useState(true);  

  const [disabledButton, setDisabledButton] = useState(true);  
  const [isLoadingButton, setIsLoadingButton] = useState(false);

  const history = useHistory();

  const handleTitleChange = (event) => {
    setIsValidInputTitle(true);
    const value = event.target.value;
    setTitle(value);
    setIsValidInputTitle(value.length > 0 ? true : false);

    if(value.length > 0 && message.length > 0){
      setDisabledButton(false);
    } else {
      setDisabledButton(true);
    }
  };

  const handleMessageChange = (event) => {
    setIsValidInputMessage(true);
    const value = event.target.value;
    setMessage(value);
    setIsValidInputMessage(value.length > 0 ? true : false);

    if(title.length > 0 && value.length > 0){
      setDisabledButton(false);
    } else {
      setDisabledButton(true);
    }
  };

  const handleCreateObject = async () => {
    setIsLoadingButton(true);

    try {
      const data = {
        title,
        message
      };

      const response = await apiService.createTicket(data);
      if(response.data === false || response.statusCode !== 200){
        setErrorCard(response.message);
        setIsLoadingButton(false);
        return;
      }

      history.push(`/contact-support/${response?.data?.id}`); 
    } catch(e){
      setErrorCard(true);
      setIsLoadingButton(false);
      return;
    }
  };

  return (
    <Box mt="24px">
      <Breadcrumbs target='Request history' url='/contact-support' current='Livechat' />

    	<Grid mt={{base: '0', lg: '-40px'}} alignItems="center" templateColumns={{ sm: '1fr', md: '0.8fr 1fr' }} gap="10px" templateRows='1fr'>
        <Box maxW={{ base: '100%', md: '471px' }}>

          { errorCard && ( <ErrorCard error={errorCard} maxW="840px" /> )}

          <Flex gap="8px" position="relative">
            <Text variant="header" fontSize="36px">
              Create Ticket
            </Text>
            <StarsIcon mt="14px" fontSize="16px" />
            <Box className="abstract-grad" transform="scale(0.6)" mt="20px" position="absolute" />
          </Flex>

          <Text textAlign="left" p="20px 0 32px 0" maxW={{base: '100%', lg: '90%'}}>
            We are ready to help!
            Before we procced, please name an issue that you
            experience and try to provide as much detailed description as possible.
          </Text>

          <FormControl id="title" mb="16px">
            <Input
              value={title}
              onChange={handleTitleChange}
              className={isValidInputTitle ? 'input-valid' : 'input-invalid'}
              type='text'
              placeholder='Name the issue'
              autoComplete="off"
            />
          </FormControl>

          <FormControl id="message" mb="32px">
            <Textarea
              value={message}
              onChange={handleMessageChange}
              className={isValidInputMessage ? 'input-valid' : 'input-invalid'}
              type='message'
              placeholder='Detailed description'
              autoComplete="off"
            />
          </FormControl>

          <Button variant="button-lg" isLoading={isLoadingButton} disabled={disabledButton} onClick={handleCreateObject}>Send</Button>
        </Box>

        <Box position="relative" display={{ base: 'none', md: 'block' }}>
          <Image src={glow} alt="Support" />
          <Box className="abstract-grad" top="50%" left="50%" transform="translate(-50%, -50%) scale(1.5)" />
        </Box>
      </Grid>
    </Box>
  );
};

export default TicketCreate;